import { defineNuxtPlugin } from 'nuxt/app'
import { USER_INFO } from '~/src/constants/common'
import { logError } from '~/utils/log-error'
import type { TCommon } from '~/src/types/common'

export default defineNuxtPlugin({
  name: 'hubspot-identity',
  dependsOn: ['cookies'],
  setup(nuxtApp: TCommon) {
    const { $cookies }: any = nuxtApp

    const getUserId = (user: any) => {
      try {
        if (!user || !user.id) {
          return ''
        }
        const decoded = window.atob(user.id)
        const [, id] = decoded.split(':')
        return id || ''
      } catch (error) {
        logError(new Error('Failed to decode user ID: ' + error.message))
        return ''
      }
    }

    /**
     * Identify the user in HubSpot. Docs: https://developers.hubspot.com/docs/api/events/tracking-code?_ga=2.208975890.101053308.1706540799-1452547414.1706540799
     *
     * @param options - Optional parameters for identification
     * @param retries - Number of retries attempted
     */
    const identifyUser = (options?: { hubspotIdentity?: any }, retries = 0) => {
      const user = $cookies.get(USER_INFO)

      // If there is no user, do nothing
      if (!user || !user?.email) {
        return
      }

      if (window._hsq) {
        window._hsq.push([
          'identify',
          {
            id: getUserId(user),
            email: user.email,
          },
        ])
      } else if (retries < 5) {
        setTimeout(() => identifyUser(options, retries + 1), 500)
      } else {
        logError(
          new Error('Hubspot tracking unavailable after maximum retries'),
        )
      }
    }

    // Identify the user if there is a user
    identifyUser()

    // Provide the hubspotIdentity object directly
    nuxtApp?.provide({
      hubspotIdentity: {
        identifyUser,
      },
    })

    return {
      provide: {
        hubspotIdentity: {
          identifyUser,
        },
      },
    }
  },
})
